import React from "react";
import { Link } from "react-router-dom";
import "./Transaction.css";
import DashMenu from "../../../../atoms/DashMenu/DashMenu";
import SubHeader from "../../../../atoms/SubHeader/SubHeader";

const Transaction = ({ toggleMenu, showMenu }) => {
  const decor = {
    textDecoration: "none",
  };
  return (
    <div className="dashboard-home-wrapper">
      <div className="dashmenu-style">
        <DashMenu toggleMenu={toggleMenu} showMenu={showMenu} />
      </div>
      <SubHeader title={"TRANSACTION"}/>
      <div className="transact-wrapper">
        <div className="balance">
          <h2>Total Account Balance</h2>
          <h3>₦2,000,000</h3>
        </div>
        <hr />
        <span className="flex-fiat">
          <p>Fiat:</p> <h3>₦2,000,000</h3>
        </span>
        <span className="flex-fiat">
          <p>Crypto:</p> <h3>2,000,000 FIDA</h3>
        </span>
        <div className="deposit">
          <Link style={decor} to="/listings" className="search-link">
            Deposit
          </Link>
          <Link style={decor} to="/listings" className="search-link">
            Withdraw
          </Link>
        </div>
      </div>
      <div className="transact-history">
        <h3>Recent Transactions</h3>
        <div className="transact-inner">
          <div className="history-content">
            <div className="charge">
              <h4>Charge deducted | </h4>
              <h4>2022-03-21 |</h4>
            </div>
            <p>
              A sum of 20 FIDA was deducted from your wallet for a viewed
              property
            </p>
            <h5>March 21 2021</h5>
          </div>
        </div>
        <div className="transact-inner">
          <div className="history-content">
            <div className="charge">
              <h4>Charge deducted | </h4>
              <h4>2022-03-21 |</h4>
            </div>
            <p>
              A sum of 20 FIDA was deducted from your wallet for a viewed
              property
            </p>
            <h5>March 21 2021</h5>
          </div>
        </div>
        <div className="transact-inner">
          <div className="history-content">
            <div className="charge">
              <h4>Charge deducted | </h4>
              <h4>2022-03-21 |</h4>
            </div>
            <p>
              A sum of 20 FIDA was deducted from your wallet for a viewed
              property
            </p>
            <h5>March 21 2021</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transaction;
